import React, { useEffect, useState } from "react";

export const ErrorPage = ({}) => {
  return (
    <div>
      <h2>An error has occurred!</h2>
    </div>
  );
};
